// extracted by mini-css-extract-plugin
export default {"Room__select_container":"RoomTypeSelector_Room__select_container__-lAd3","Room__select_buttons":"RoomTypeSelector_Room__select_buttons__OoOdV"};